<script setup>
// Components
import ImgMedia from '@/Components/Images/ImgMedia.vue';

const props = defineProps({
    image: String,
});
</script>
<template>
    <div class="container relative flex justify-center py-12 md:py-16">
        <div class="md:w-8/12">
            <ImgMedia v-if="image" :media="image" :classes="'rounded-xl w-full h-auto'" />
        </div>
    </div>
</template>
